<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
    <meta name="viewport" content="width=device-width,initial-scale=1">
    <title>Font Reference - font-xpectra-icons</title>
    <link href="http://fonts.googleapis.com/css?family=Dosis:400,500,700" rel="stylesheet" type="text/css">
    <link rel="stylesheet" href="css/font-xpectra-icons.css">
    <style type="text/css">html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td{margin:0;padding:0;border:0;outline:0;font-weight:inherit;font-style:inherit;font-family:inherit;font-size:100%;vertical-align:baseline}body{line-height:1;color:#000;background:#fff}ol,ul{list-style:none}table{border-collapse:separate;border-spacing:0;vertical-align:middle}caption,th,td{text-align:left;font-weight:normal;vertical-align:middle}a img{border:none}*{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}body{font-family:'Dosis','Tahoma',sans-serif}.container{margin:15px auto;width:80%}h1{margin:40px 0 20px;font-weight:700;font-size:38px;line-height:32px;color:#fb565e}h2{font-size:18px;padding:0 0 21px 5px;margin:45px 0 0 0;text-transform:uppercase;font-weight:500}.small{font-size:14px;color:#a5adb4;}.small a{color:#a5adb4;}.small a:hover{color:#fb565e}.glyphs.character-mapping{margin:0 0 20px 0;padding:20px 0 20px 30px;color:rgba(0,0,0,0.5);border:1px solid #d8e0e5;-webkit-border-radius:3px;border-radius:3px;}.glyphs.character-mapping li{margin:0 30px 20px 0;display:inline-block;width:90px}.glyphs.character-mapping .icon{margin:10px 0 10px 15px;padding:15px;position:relative;width:55px;height:55px;color:#162a36 !important;overflow:hidden;-webkit-border-radius:3px;border-radius:3px;font-size:32px;}.glyphs.character-mapping .icon svg{fill:#000}.glyphs.character-mapping input{margin:0;padding:5px 0;line-height:12px;font-size:12px;display:block;width:100%;border:1px solid #d8e0e5;-webkit-border-radius:5px;border-radius:5px;text-align:center;outline:0;}.glyphs.character-mapping input:focus{border:1px solid #fbde4a;-webkit-box-shadow:inset 0 0 3px #fbde4a;box-shadow:inset 0 0 3px #fbde4a}.glyphs.character-mapping input:hover{-webkit-box-shadow:inset 0 0 3px #fbde4a;box-shadow:inset 0 0 3px #fbde4a}.glyphs.css-mapping{margin:0 0 60px 0;padding:30px 0 20px 30px;color:rgba(0,0,0,0.5);border:1px solid #d8e0e5;-webkit-border-radius:3px;border-radius:3px;}.glyphs.css-mapping li{margin:0 30px 20px 0;padding:0;display:inline-block;overflow:hidden}.glyphs.css-mapping .icon{margin:0;margin-right:10px;padding:13px;height:50px;width:50px;color:#162a36 !important;overflow:hidden;float:left;font-size:24px}.glyphs.css-mapping input{margin:0;margin-top:5px;padding:8px;line-height:16px;font-size:16px;display:block;width:150px;height:40px;border:1px solid #d8e0e5;-webkit-border-radius:5px;border-radius:5px;background:#fff;outline:0;float:right;}.glyphs.css-mapping input:focus{border:1px solid #fbde4a;-webkit-box-shadow:inset 0 0 3px #fbde4a;box-shadow:inset 0 0 3px #fbde4a}.glyphs.css-mapping input:hover{-webkit-box-shadow:inset 0 0 3px #fbde4a;box-shadow:inset 0 0 3px #fbde4a}</style>
  </head>
  <body>
    <div class="container">
      <h1>font-xpectra-icons</h1>
      <p class="small">This font was created with<a href="http://fontastic.me/">Fontastic</a></p>
      <h2>CSS mapping</h2>
      <ul class="glyphs css-mapping">
        <li>
          <div class="icon icon-ico-ed-alarma"></div>
          <input type="text" readonly="readonly" value="ico-ed-alarma">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-calor"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-calor">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-congelamiento"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-congelamiento">
        </li>
        <li>
          <div class="icon icon-ico-ed-boton-panico"></div>
          <input type="text" readonly="readonly" value="ico-ed-boton-panico">
        </li>
        <li>
          <div class="icon icon-ico-ed-camara"></div>
          <input type="text" readonly="readonly" value="ico-ed-camara">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-fuego"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-fuego">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-gas"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-gas">
        </li>
        <li>
          <div class="icon icon-ico-ed-camara-ip"></div>
          <input type="text" readonly="readonly" value="ico-ed-camara-ip">
        </li>
        <li>
          <div class="icon icon-ico-ed-camara-ip-wifi"></div>
          <input type="text" readonly="readonly" value="ico-ed-camara-ip-wifi">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-inundacion"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-inundacion">
        </li>
        <li>
          <div class="icon icon-ico-ed-camara-ptz"></div>
          <input type="text" readonly="readonly" value="ico-ed-camara-ptz">
        </li>
        <li>
          <div class="icon icon-ico-ed-camara-ptz-ip"></div>
          <input type="text" readonly="readonly" value="ico-ed-camara-ptz-ip">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-presencia"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-presencia">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-rotura"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-rotura">
        </li>
        <li>
          <div class="icon icon-ico-ed-camara-ptz-ip-wifi"></div>
          <input type="text" readonly="readonly" value="ico-ed-camara-ptz-ip-wifi">
        </li>
        <li>
          <div class="icon icon-ico-ed-dvr"></div>
          <input type="text" readonly="readonly" value="ico-ed-dvr">
        </li>
        <li>
          <div class="icon icon-ico-ed-sirena"></div>
          <input type="text" readonly="readonly" value="ico-ed-sirena">
        </li>
        <li>
          <div class="icon icon-ico-ed-teclado"></div>
          <input type="text" readonly="readonly" value="ico-ed-teclado">
        </li>
        <li>
          <div class="icon icon-ico-ed-nvr"></div>
          <input type="text" readonly="readonly" value="ico-ed-nvr">
        </li>
        <li>
          <div class="icon icon-ico-ed-panel"></div>
          <input type="text" readonly="readonly" value="ico-ed-panel">
        </li>
        <li>
          <div class="icon icon-ico-ed-rociador-agua"></div>
          <input type="text" readonly="readonly" value="ico-ed-rociador-agua">
        </li>
        <li>
          <div class="icon icon-ico-ed-sensor-apertura"></div>
          <input type="text" readonly="readonly" value="ico-ed-sensor-apertura">
        </li>
        <li>
          <div class="icon icon-ico-ea-alarma"></div>
          <input type="text" readonly="readonly" value="ico-ea-alarma">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-auto-falla"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-auto-falla">
        </li>
        <li>
          <div class="icon icon-ico-ea-calor-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-calor-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-congelamiento"></div>
          <input type="text" readonly="readonly" value="ico-ea-congelamiento">
        </li>
        <li>
          <div class="icon icon-ico-ea-falla-baterias"></div>
          <input type="text" readonly="readonly" value="ico-ea-falla-baterias">
        </li>
        <li>
          <div class="icon icon-ico-ea-falla-comunicacion"></div>
          <input type="text" readonly="readonly" value="ico-ea-falla-comunicacion">
        </li>
        <li>
          <div class="icon icon-ico-ea-congelamiento-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-congelamiento-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-cambio-programacion"></div>
          <input type="text" readonly="readonly" value="ico-ea-cambio-programacion">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-automatico"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-automatico">
        </li>
        <li>
          <div class="icon icon-ico-ea-alarma-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-alarma-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-apertura"></div>
          <input type="text" readonly="readonly" value="ico-ea-apertura">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-falla"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-falla">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado">
        </li>
        <li>
          <div class="icon icon-ico-ea-falla-netbox"></div>
          <input type="text" readonly="readonly" value="ico-ea-falla-netbox">
        </li>
        <li>
          <div class="icon icon-ico-ea-falla-potencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-falla-potencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-fuera-horario"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-fuera-horario">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-parcial"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-parcial">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-automatico"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-automatico">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado-automatico"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado-automatico">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado-falla"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado-falla">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-falla"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-falla">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-remoto"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-remoto">
        </li>
        <li>
          <div class="icon icon-ico-ea-apertura-falla"></div>
          <input type="text" readonly="readonly" value="ico-ea-apertura-falla">
        </li>
        <li>
          <div class="icon icon-ico-ea-apertura-fuera-horario"></div>
          <input type="text" readonly="readonly" value="ico-ea-apertura-fuera-horario">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-tardio"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-tardio">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-fuera-horario"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-fuera-horario">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado-fuera-horario"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado-fuera-horario">
        </li>
        <li>
          <div class="icon icon-ico-ea-fuego"></div>
          <input type="text" readonly="readonly" value="ico-ea-fuego">
        </li>
        <li>
          <div class="icon icon-ico-ea-falla-zona"></div>
          <input type="text" readonly="readonly" value="ico-ea-falla-zona">
        </li>
        <li>
          <div class="icon icon-ico-ea-falla-receptora"></div>
          <input type="text" readonly="readonly" value="ico-ea-falla-receptora">
        </li>
        <li>
          <div class="icon icon-ico-ea-intrusion-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-intrusion-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-inundacion"></div>
          <input type="text" readonly="readonly" value="ico-ea-inundacion">
        </li>
        <li>
          <div class="icon icon-ico-ea-inundacion-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-inundacion-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-medico"></div>
          <input type="text" readonly="readonly" value="ico-ea-medico">
        </li>
        <li>
          <div class="icon icon-ico-ea-medico-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-medico-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-fuego"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-fuego">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-fuego-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-fuego-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-fuego-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-fuego-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado-remoto"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado-remoto">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-parcial"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-parcial">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-temprano"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-temprano">
        </li>
        <li>
          <div class="icon icon-ico-ea-apertura-remoto"></div>
          <input type="text" readonly="readonly" value="ico-ea-apertura-remoto">
        </li>
        <li>
          <div class="icon icon-ico-ea-apertura-tarde"></div>
          <input type="text" readonly="readonly" value="ico-ea-apertura-tarde">
        </li>
        <li>
          <div class="icon icon-ico-ea-asistencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-asistencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-remoto"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-remoto">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado-tardio"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado-tardio">
        </li>
        <li>
          <div class="icon icon-ico-ea-gas"></div>
          <input type="text" readonly="readonly" value="ico-ea-gas">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-inundacion"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-inundacion">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-inundacion-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-inundacion-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-gas-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-gas-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado-temprano"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado-temprano">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-tarde"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-tarde">
        </li>
        <li>
          <div class="icon icon-ico-ea-asistencia-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-asistencia-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-apertura-temprano"></div>
          <input type="text" readonly="readonly" value="ico-ea-apertura-temprano">
        </li>
        <li>
          <div class="icon icon-ico-ea-aperturas-cierres"></div>
          <input type="text" readonly="readonly" value="ico-ea-aperturas-cierres">
        </li>
        <li>
          <div class="icon icon-ico-ea-bypass"></div>
          <input type="text" readonly="readonly" value="ico-ea-bypass">
        </li>
        <li>
          <div class="icon icon-ico-ea-emergencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-emergencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-temprano"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-temprano">
        </li>
        <li>
          <div class="icon icon-ico-ea-co2"></div>
          <input type="text" readonly="readonly" value="ico-ea-co2">
        </li>
        <li>
          <div class="icon icon-ico-ea-bypass-normalizacion"></div>
          <input type="text" readonly="readonly" value="ico-ea-bypass-normalizacion">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado">
        </li>
        <li>
          <div class="icon icon-ico-ea-calor"></div>
          <input type="text" readonly="readonly" value="ico-ea-calor">
        </li>
        <li>
          <div class="icon icon-ico-ea-co2-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-co2-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-falla"></div>
          <input type="text" readonly="readonly" value="ico-ea-falla">
        </li>
        <li>
          <div class="icon icon-ico-ea-emergencia-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-emergencia-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-intrusion"></div>
          <input type="text" readonly="readonly" value="ico-ea-intrusion">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-medico-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-medico-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-medico"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-medico">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-robo-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-robo-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-reporte"></div>
          <input type="text" readonly="readonly" value="ico-ea-reporte">
        </li>
        <li>
          <div class="icon icon-ico-ea-tamper"></div>
          <input type="text" readonly="readonly" value="ico-ea-tamper">
        </li>
        <li>
          <div class="icon icon-ico-ea-supervisor"></div>
          <input type="text" readonly="readonly" value="ico-ea-supervisor">
        </li>
        <li>
          <div class="icon icon-ico-ea-sometido-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-sometido-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-sometido"></div>
          <input type="text" readonly="readonly" value="ico-ea-sometido">
        </li>
        <li>
          <div class="icon icon-ico-ea-senal-test"></div>
          <input type="text" readonly="readonly" value="ico-ea-senal-test">
        </li>
        <li>
          <div class="icon icon-ico-ea-senal-no-configurada"></div>
          <input type="text" readonly="readonly" value="ico-ea-senal-no-configurada">
        </li>
        <li>
          <div class="icon icon-ico-ea-senal-desconocida"></div>
          <input type="text" readonly="readonly" value="ico-ea-senal-desconocida">
        </li>
        <li>
          <div class="icon icon-ico-ea-rociador-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-rociador-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-rociador"></div>
          <input type="text" readonly="readonly" value="ico-ea-rociador">
        </li>
        <li>
          <div class="icon icon-ico-ea-robo-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-robo-zc">
        </li>
        <li>
          <div class="icon icon-ico-ea-robo"></div>
          <input type="text" readonly="readonly" value="ico-ea-robo">
        </li>
        <li>
          <div class="icon icon-ico-ea-reporte-cona"></div>
          <input type="text" readonly="readonly" value="ico-ea-reporte-cona">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-alt"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-alt">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-asistencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-asistencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-asistencia-alt"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-asistencia-alt">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-fuego-alt"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-fuego-alt">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-medico"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-medico">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-medico-alt"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-medico-alt">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-robo"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-robo">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-robo-alt"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-robo-alt">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-robo"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-robo">
        </li>
        <li>
          <div class="icon icon-ico-ea-panico-movil-fuego"></div>
          <input type="text" readonly="readonly" value="ico-ea-panico-movil-fuego">
        </li>
        <li>
          <div class="icon icon-ico-cloud-actualizar"></div>
          <input type="text" readonly="readonly" value="ico-cloud-actualizar">
        </li>
        <li>
          <div class="icon icon-ico-cloud-facturacion-pagos"></div>
          <input type="text" readonly="readonly" value="ico-cloud-facturacion-pagos">
        </li>
        <li>
          <div class="icon icon-ico-cloud-solicitud"></div>
          <input type="text" readonly="readonly" value="ico-cloud-solicitud">
        </li>
        <li>
          <div class="icon icon-ico-cloud-solicitud-cancelada"></div>
          <input type="text" readonly="readonly" value="ico-cloud-solicitud-cancelada">
        </li>
        <li>
          <div class="icon icon-ico-cloud-idioma"></div>
          <input type="text" readonly="readonly" value="ico-cloud-idioma">
        </li>
        <li>
          <div class="icon icon-ico-cloud-ajustes"></div>
          <input type="text" readonly="readonly" value="ico-cloud-ajustes">
        </li>
        <li>
          <div class="icon icon-ico-cloud-alarmas-eventos"></div>
          <input type="text" readonly="readonly" value="ico-cloud-alarmas-eventos">
        </li>
        <li>
          <div class="icon icon-ico-cloud-localizacion-en-mapa"></div>
          <input type="text" readonly="readonly" value="ico-cloud-localizacion-en-mapa">
        </li>
        <li>
          <div class="icon icon-ico-cloud-soporte-t-ecnico-alt"></div>
          <input type="text" readonly="readonly" value="ico-cloud-soporte-t-ecnico-alt">
        </li>
        <li>
          <div class="icon icon-ico-cloud-soporte-tecnico"></div>
          <input type="text" readonly="readonly" value="ico-cloud-soporte-tecnico">
        </li>
        <li>
          <div class="icon icon-ico-cloud-mapa"></div>
          <input type="text" readonly="readonly" value="ico-cloud-mapa">
        </li>
        <li>
          <div class="icon icon-ico-cloud-borrar"></div>
          <input type="text" readonly="readonly" value="ico-cloud-borrar">
        </li>
        <li>
          <div class="icon icon-ico-cloud-calendario"></div>
          <input type="text" readonly="readonly" value="ico-cloud-calendario">
        </li>
        <li>
          <div class="icon icon-ico-cloud-notificaciones"></div>
          <input type="text" readonly="readonly" value="ico-cloud-notificaciones">
        </li>
        <li>
          <div class="icon icon-ico-cloud-telefono"></div>
          <input type="text" readonly="readonly" value="ico-cloud-telefono">
        </li>
        <li>
          <div class="icon icon-ico-cloud-ticket"></div>
          <input type="text" readonly="readonly" value="ico-cloud-ticket">
        </li>
        <li>
          <div class="icon icon-ico-cloud-nueva-solicitud"></div>
          <input type="text" readonly="readonly" value="ico-cloud-nueva-solicitud">
        </li>
        <li>
          <div class="icon icon-ico-cloud-camara"></div>
          <input type="text" readonly="readonly" value="ico-cloud-camara">
        </li>
        <li>
          <div class="icon icon-ico-cloud-cliente"></div>
          <input type="text" readonly="readonly" value="ico-cloud-cliente">
        </li>
        <li>
          <div class="icon icon-ico-cloud-pagos"></div>
          <input type="text" readonly="readonly" value="ico-cloud-pagos">
        </li>
        <li>
          <div class="icon icon-ico-cloud-ticket-en-proceso"></div>
          <input type="text" readonly="readonly" value="ico-cloud-ticket-en-proceso">
        </li>
        <li>
          <div class="icon icon-ico-cloud-ticket-finalizado"></div>
          <input type="text" readonly="readonly" value="ico-cloud-ticket-finalizado">
        </li>
        <li>
          <div class="icon icon-ico-cloud-panel-armado"></div>
          <input type="text" readonly="readonly" value="ico-cloud-panel-armado">
        </li>
        <li>
          <div class="icon icon-ico-cloud-configuracin-cuenta"></div>
          <input type="text" readonly="readonly" value="ico-cloud-configuracin-cuenta">
        </li>
        <li>
          <div class="icon icon-ico-cloud-cuenta"></div>
          <input type="text" readonly="readonly" value="ico-cloud-cuenta">
        </li>
        <li>
          <div class="icon icon-ico-cloud-panel-desarmado"></div>
          <input type="text" readonly="readonly" value="ico-cloud-panel-desarmado">
        </li>
        <li>
          <div class="icon icon-ico-cloud-ticket-planificado"></div>
          <input type="text" readonly="readonly" value="ico-cloud-ticket-planificado">
        </li>
        <li>
          <div class="icon icon-ico-cloud-panel-zonas-alarma"></div>
          <input type="text" readonly="readonly" value="ico-cloud-panel-zonas-alarma">
        </li>
        <li>
          <div class="icon icon-ico-cloud-cuenta-alt"></div>
          <input type="text" readonly="readonly" value="ico-cloud-cuenta-alt">
        </li>
        <li>
          <div class="icon icon-ico-cloud-detalle-cuenta"></div>
          <input type="text" readonly="readonly" value="ico-cloud-detalle-cuenta">
        </li>
        <li>
          <div class="icon icon-ico-cloud-panel-zonas-bypass"></div>
          <input type="text" readonly="readonly" value="ico-cloud-panel-zonas-bypass">
        </li>
        <li>
          <div class="icon icon-ico-cloud-reportes"></div>
          <input type="text" readonly="readonly" value="ico-cloud-reportes">
        </li>
        <li>
          <div class="icon icon-ico-cloud-email"></div>
          <input type="text" readonly="readonly" value="ico-cloud-email">
        </li>
        <li>
          <div class="icon icon-ico-cloud-facturacion"></div>
          <input type="text" readonly="readonly" value="ico-cloud-facturacion">
        </li>
        <li>
          <div class="icon icon-ico-cloud-salir"></div>
          <input type="text" readonly="readonly" value="ico-cloud-salir">
        </li>
        <li>
          <div class="icon icon-ico-cloud-apps-panico"></div>
          <input type="text" readonly="readonly" value="ico-cloud-apps-panico">
        </li>
        <li>
          <div class="icon icon-ico-cancelar"></div>
          <input type="text" readonly="readonly" value="ico-cancelar">
        </li>
        <li>
          <div class="icon icon-ico-pausar"></div>
          <input type="text" readonly="readonly" value="ico-pausar">
        </li>
        <li>
          <div class="icon icon-aceptar"></div>
          <input type="text" readonly="readonly" value="aceptar">
        </li>
        <li>
          <div class="icon icon-atender"></div>
          <input type="text" readonly="readonly" value="atender">
        </li>
        <li>
          <div class="icon icon-detalle"></div>
          <input type="text" readonly="readonly" value="detalle">
        </li>
        <li>
          <div class="icon icon-historial"></div>
          <input type="text" readonly="readonly" value="historial">
        </li>
        <li>
          <div class="icon icon-nota"></div>
          <input type="text" readonly="readonly" value="nota">
        </li>
        <li>
          <div class="icon icon-pausar"></div>
          <input type="text" readonly="readonly" value="pausar">
        </li>
        <li>
          <div class="icon icon-rechazar"></div>
          <input type="text" readonly="readonly" value="rechazar">
        </li>
        <li>
          <div class="icon icon-terminar"></div>
          <input type="text" readonly="readonly" value="terminar">
        </li>
        <li>
          <div class="icon icon-ico-ea-apertura-ausencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-apertura-ausencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-armado-ausencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-armado-ausencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-cierre-ausencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-cierre-ausencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-desarmado-ausencia"></div>
          <input type="text" readonly="readonly" value="ico-ea-desarmado-ausencia">
        </li>
        <li>
          <div class="icon icon-ico-ea-humo"></div>
          <input type="text" readonly="readonly" value="ico-ea-humo">
        </li>
        <li>
          <div class="icon icon-ico-ea-humo-zc"></div>
          <input type="text" readonly="readonly" value="ico-ea-humo-zc">
        </li>
        <li>
          <div class="icon icon-ico-sec-ayuda"></div>
          <input type="text" readonly="readonly" value="ico-sec-ayuda">
        </li>
      </ul>
      <h2>Character mapping</h2>
      <ul class="glyphs character-mapping">
        <li>
          <div data-icon="a" class="icon"></div>
          <input type="text" readonly="readonly" value="a">
        </li>
        <li>
          <div data-icon="b" class="icon"></div>
          <input type="text" readonly="readonly" value="b">
        </li>
        <li>
          <div data-icon="c" class="icon"></div>
          <input type="text" readonly="readonly" value="c">
        </li>
        <li>
          <div data-icon="d" class="icon"></div>
          <input type="text" readonly="readonly" value="d">
        </li>
        <li>
          <div data-icon="e" class="icon"></div>
          <input type="text" readonly="readonly" value="e">
        </li>
        <li>
          <div data-icon="f" class="icon"></div>
          <input type="text" readonly="readonly" value="f">
        </li>
        <li>
          <div data-icon="g" class="icon"></div>
          <input type="text" readonly="readonly" value="g">
        </li>
        <li>
          <div data-icon="h" class="icon"></div>
          <input type="text" readonly="readonly" value="h">
        </li>
        <li>
          <div data-icon="i" class="icon"></div>
          <input type="text" readonly="readonly" value="i">
        </li>
        <li>
          <div data-icon="k" class="icon"></div>
          <input type="text" readonly="readonly" value="k">
        </li>
        <li>
          <div data-icon="l" class="icon"></div>
          <input type="text" readonly="readonly" value="l">
        </li>
        <li>
          <div data-icon="m" class="icon"></div>
          <input type="text" readonly="readonly" value="m">
        </li>
        <li>
          <div data-icon="n" class="icon"></div>
          <input type="text" readonly="readonly" value="n">
        </li>
        <li>
          <div data-icon="j" class="icon"></div>
          <input type="text" readonly="readonly" value="j">
        </li>
        <li>
          <div data-icon="o" class="icon"></div>
          <input type="text" readonly="readonly" value="o">
        </li>
        <li>
          <div data-icon="p" class="icon"></div>
          <input type="text" readonly="readonly" value="p">
        </li>
        <li>
          <div data-icon="q" class="icon"></div>
          <input type="text" readonly="readonly" value="q">
        </li>
        <li>
          <div data-icon="r" class="icon"></div>
          <input type="text" readonly="readonly" value="r">
        </li>
        <li>
          <div data-icon="s" class="icon"></div>
          <input type="text" readonly="readonly" value="s">
        </li>
        <li>
          <div data-icon="t" class="icon"></div>
          <input type="text" readonly="readonly" value="t">
        </li>
        <li>
          <div data-icon="u" class="icon"></div>
          <input type="text" readonly="readonly" value="u">
        </li>
        <li>
          <div data-icon="v" class="icon"></div>
          <input type="text" readonly="readonly" value="v">
        </li>
        <li>
          <div data-icon="w" class="icon"></div>
          <input type="text" readonly="readonly" value="w">
        </li>
        <li>
          <div data-icon="x" class="icon"></div>
          <input type="text" readonly="readonly" value="x">
        </li>
        <li>
          <div data-icon="y" class="icon"></div>
          <input type="text" readonly="readonly" value="y">
        </li>
        <li>
          <div data-icon="z" class="icon"></div>
          <input type="text" readonly="readonly" value="z">
        </li>
        <li>
          <div data-icon="A" class="icon"></div>
          <input type="text" readonly="readonly" value="A">
        </li>
        <li>
          <div data-icon="B" class="icon"></div>
          <input type="text" readonly="readonly" value="B">
        </li>
        <li>
          <div data-icon="C" class="icon"></div>
          <input type="text" readonly="readonly" value="C">
        </li>
        <li>
          <div data-icon="D" class="icon"></div>
          <input type="text" readonly="readonly" value="D">
        </li>
        <li>
          <div data-icon="E" class="icon"></div>
          <input type="text" readonly="readonly" value="E">
        </li>
        <li>
          <div data-icon="F" class="icon"></div>
          <input type="text" readonly="readonly" value="F">
        </li>
        <li>
          <div data-icon="G" class="icon"></div>
          <input type="text" readonly="readonly" value="G">
        </li>
        <li>
          <div data-icon="H" class="icon"></div>
          <input type="text" readonly="readonly" value="H">
        </li>
        <li>
          <div data-icon="I" class="icon"></div>
          <input type="text" readonly="readonly" value="I">
        </li>
        <li>
          <div data-icon="L" class="icon"></div>
          <input type="text" readonly="readonly" value="L">
        </li>
        <li>
          <div data-icon="M" class="icon"></div>
          <input type="text" readonly="readonly" value="M">
        </li>
        <li>
          <div data-icon="N" class="icon"></div>
          <input type="text" readonly="readonly" value="N">
        </li>
        <li>
          <div data-icon="O" class="icon"></div>
          <input type="text" readonly="readonly" value="O">
        </li>
        <li>
          <div data-icon="P" class="icon"></div>
          <input type="text" readonly="readonly" value="P">
        </li>
        <li>
          <div data-icon="Q" class="icon"></div>
          <input type="text" readonly="readonly" value="Q">
        </li>
        <li>
          <div data-icon="J" class="icon"></div>
          <input type="text" readonly="readonly" value="J">
        </li>
        <li>
          <div data-icon="K" class="icon"></div>
          <input type="text" readonly="readonly" value="K">
        </li>
        <li>
          <div data-icon="R" class="icon"></div>
          <input type="text" readonly="readonly" value="R">
        </li>
        <li>
          <div data-icon="S" class="icon"></div>
          <input type="text" readonly="readonly" value="S">
        </li>
        <li>
          <div data-icon="T" class="icon"></div>
          <input type="text" readonly="readonly" value="T">
        </li>
        <li>
          <div data-icon="U" class="icon"></div>
          <input type="text" readonly="readonly" value="U">
        </li>
        <li>
          <div data-icon="V" class="icon"></div>
          <input type="text" readonly="readonly" value="V">
        </li>
        <li>
          <div data-icon="W" class="icon"></div>
          <input type="text" readonly="readonly" value="W">
        </li>
        <li>
          <div data-icon="X" class="icon"></div>
          <input type="text" readonly="readonly" value="X">
        </li>
        <li>
          <div data-icon="Y" class="icon"></div>
          <input type="text" readonly="readonly" value="Y">
        </li>
        <li>
          <div data-icon="Z" class="icon"></div>
          <input type="text" readonly="readonly" value="Z">
        </li>
        <li>
          <div data-icon="0" class="icon"></div>
          <input type="text" readonly="readonly" value="0">
        </li>
        <li>
          <div data-icon="1" class="icon"></div>
          <input type="text" readonly="readonly" value="1">
        </li>
        <li>
          <div data-icon="2" class="icon"></div>
          <input type="text" readonly="readonly" value="2">
        </li>
        <li>
          <div data-icon="3" class="icon"></div>
          <input type="text" readonly="readonly" value="3">
        </li>
        <li>
          <div data-icon="4" class="icon"></div>
          <input type="text" readonly="readonly" value="4">
        </li>
        <li>
          <div data-icon="5" class="icon"></div>
          <input type="text" readonly="readonly" value="5">
        </li>
        <li>
          <div data-icon="6" class="icon"></div>
          <input type="text" readonly="readonly" value="6">
        </li>
        <li>
          <div data-icon="7" class="icon"></div>
          <input type="text" readonly="readonly" value="7">
        </li>
        <li>
          <div data-icon="8" class="icon"></div>
          <input type="text" readonly="readonly" value="8">
        </li>
        <li>
          <div data-icon="9" class="icon"></div>
          <input type="text" readonly="readonly" value="9">
        </li>
        <li>
          <div data-icon="!" class="icon"></div>
          <input type="text" readonly="readonly" value="!">
        </li>
        <li>
          <div data-icon="&#34;" class="icon"></div>
          <input type="text" readonly="readonly" value="&quot;">
        </li>
        <li>
          <div data-icon="#" class="icon"></div>
          <input type="text" readonly="readonly" value="#">
        </li>
        <li>
          <div data-icon="$" class="icon"></div>
          <input type="text" readonly="readonly" value="$">
        </li>
        <li>
          <div data-icon="%" class="icon"></div>
          <input type="text" readonly="readonly" value="%">
        </li>
        <li>
          <div data-icon="&" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;">
        </li>
        <li>
          <div data-icon="'" class="icon"></div>
          <input type="text" readonly="readonly" value="&#39;">
        </li>
        <li>
          <div data-icon="(" class="icon"></div>
          <input type="text" readonly="readonly" value="(">
        </li>
        <li>
          <div data-icon=")" class="icon"></div>
          <input type="text" readonly="readonly" value=")">
        </li>
        <li>
          <div data-icon="*" class="icon"></div>
          <input type="text" readonly="readonly" value="*">
        </li>
        <li>
          <div data-icon="+" class="icon"></div>
          <input type="text" readonly="readonly" value="+">
        </li>
        <li>
          <div data-icon="," class="icon"></div>
          <input type="text" readonly="readonly" value=",">
        </li>
        <li>
          <div data-icon="-" class="icon"></div>
          <input type="text" readonly="readonly" value="-">
        </li>
        <li>
          <div data-icon="." class="icon"></div>
          <input type="text" readonly="readonly" value=".">
        </li>
        <li>
          <div data-icon="/" class="icon"></div>
          <input type="text" readonly="readonly" value="/">
        </li>
        <li>
          <div data-icon=":" class="icon"></div>
          <input type="text" readonly="readonly" value=":">
        </li>
        <li>
          <div data-icon=";" class="icon"></div>
          <input type="text" readonly="readonly" value=";">
        </li>
        <li>
          <div data-icon="<" class="icon"></div>
          <input type="text" readonly="readonly" value="&lt;">
        </li>
        <li>
          <div data-icon="=" class="icon"></div>
          <input type="text" readonly="readonly" value="=">
        </li>
        <li>
          <div data-icon=">" class="icon"></div>
          <input type="text" readonly="readonly" value="&gt;">
        </li>
        <li>
          <div data-icon="?" class="icon"></div>
          <input type="text" readonly="readonly" value="?">
        </li>
        <li>
          <div data-icon="@" class="icon"></div>
          <input type="text" readonly="readonly" value="@">
        </li>
        <li>
          <div data-icon="[" class="icon"></div>
          <input type="text" readonly="readonly" value="[">
        </li>
        <li>
          <div data-icon="^" class="icon"></div>
          <input type="text" readonly="readonly" value="^">
        </li>
        <li>
          <div data-icon="_" class="icon"></div>
          <input type="text" readonly="readonly" value="_">
        </li>
        <li>
          <div data-icon="`" class="icon"></div>
          <input type="text" readonly="readonly" value="`">
        </li>
        <li>
          <div data-icon="]" class="icon"></div>
          <input type="text" readonly="readonly" value="]">
        </li>
        <li>
          <div data-icon="{" class="icon"></div>
          <input type="text" readonly="readonly" value="{">
        </li>
        <li>
          <div data-icon="|" class="icon"></div>
          <input type="text" readonly="readonly" value="|">
        </li>
        <li>
          <div data-icon="}" class="icon"></div>
          <input type="text" readonly="readonly" value="}">
        </li>
        <li>
          <div data-icon="~" class="icon"></div>
          <input type="text" readonly="readonly" value="~">
        </li>
        <li>
          <div data-icon="\" class="icon"></div>
          <input type="text" readonly="readonly" value="\">
        </li>
        <li>
          <div data-icon="&#xe000;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe000;">
        </li>
        <li>
          <div data-icon="&#xe001;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe001;">
        </li>
        <li>
          <div data-icon="&#xe002;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe002;">
        </li>
        <li>
          <div data-icon="&#xe003;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe003;">
        </li>
        <li>
          <div data-icon="&#xe004;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe004;">
        </li>
        <li>
          <div data-icon="&#xe005;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe005;">
        </li>
        <li>
          <div data-icon="&#xe006;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe006;">
        </li>
        <li>
          <div data-icon="&#xe007;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe007;">
        </li>
        <li>
          <div data-icon="&#xe008;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe008;">
        </li>
        <li>
          <div data-icon="&#xe009;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe009;">
        </li>
        <li>
          <div data-icon="&#xe00a;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe00a;">
        </li>
        <li>
          <div data-icon="&#xe00b;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe00b;">
        </li>
        <li>
          <div data-icon="&#xe00c;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe00c;">
        </li>
        <li>
          <div data-icon="&#xe00d;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe00d;">
        </li>
        <li>
          <div data-icon="&#xe00e;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe00e;">
        </li>
        <li>
          <div data-icon="&#xe00f;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe00f;">
        </li>
        <li>
          <div data-icon="&#xe010;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe010;">
        </li>
        <li>
          <div data-icon="&#xe011;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe011;">
        </li>
        <li>
          <div data-icon="&#xe012;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe012;">
        </li>
        <li>
          <div data-icon="&#xe013;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe013;">
        </li>
        <li>
          <div data-icon="&#xe014;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe014;">
        </li>
        <li>
          <div data-icon="&#xe015;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe015;">
        </li>
        <li>
          <div data-icon="&#xe016;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe016;">
        </li>
        <li>
          <div data-icon="&#xe017;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe017;">
        </li>
        <li>
          <div data-icon="&#xe018;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe018;">
        </li>
        <li>
          <div data-icon="&#xe019;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe019;">
        </li>
        <li>
          <div data-icon="&#xe01a;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe01a;">
        </li>
        <li>
          <div data-icon="&#xe01b;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe01b;">
        </li>
        <li>
          <div data-icon="&#xe01c;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe01c;">
        </li>
        <li>
          <div data-icon="&#xe01d;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe01d;">
        </li>
        <li>
          <div data-icon="&#xe01e;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe01e;">
        </li>
        <li>
          <div data-icon="&#xe01f;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe01f;">
        </li>
        <li>
          <div data-icon="&#xe020;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe020;">
        </li>
        <li>
          <div data-icon="&#xe021;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe021;">
        </li>
        <li>
          <div data-icon="&#xe022;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe022;">
        </li>
        <li>
          <div data-icon="&#xe023;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe023;">
        </li>
        <li>
          <div data-icon="&#xe024;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe024;">
        </li>
        <li>
          <div data-icon="&#xe025;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe025;">
        </li>
        <li>
          <div data-icon="&#xe026;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe026;">
        </li>
        <li>
          <div data-icon="&#xe027;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe027;">
        </li>
        <li>
          <div data-icon="&#xe028;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe028;">
        </li>
        <li>
          <div data-icon="&#xe029;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe029;">
        </li>
        <li>
          <div data-icon="&#xe02a;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe02a;">
        </li>
        <li>
          <div data-icon="&#xe02b;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe02b;">
        </li>
        <li>
          <div data-icon="&#xe02c;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe02c;">
        </li>
        <li>
          <div data-icon="&#xe02d;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe02d;">
        </li>
        <li>
          <div data-icon="&#xe02e;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe02e;">
        </li>
        <li>
          <div data-icon="&#xe02f;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe02f;">
        </li>
        <li>
          <div data-icon="&#xe030;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe030;">
        </li>
        <li>
          <div data-icon="&#xe031;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe031;">
        </li>
        <li>
          <div data-icon="&#xe032;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe032;">
        </li>
        <li>
          <div data-icon="&#xe033;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe033;">
        </li>
        <li>
          <div data-icon="&#xe034;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe034;">
        </li>
        <li>
          <div data-icon="&#xe035;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe035;">
        </li>
        <li>
          <div data-icon="&#xe036;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe036;">
        </li>
        <li>
          <div data-icon="&#xe037;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe037;">
        </li>
        <li>
          <div data-icon="&#xe038;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe038;">
        </li>
        <li>
          <div data-icon="&#xe039;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe039;">
        </li>
        <li>
          <div data-icon="&#xe03a;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe03a;">
        </li>
        <li>
          <div data-icon="&#xe03b;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe03b;">
        </li>
        <li>
          <div data-icon="&#xe042;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe042;">
        </li>
        <li>
          <div data-icon="&#xe043;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe043;">
        </li>
        <li>
          <div data-icon="&#xe03c;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe03c;">
        </li>
        <li>
          <div data-icon="&#xe03d;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe03d;">
        </li>
        <li>
          <div data-icon="&#xe03e;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe03e;">
        </li>
        <li>
          <div data-icon="&#xe03f;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe03f;">
        </li>
        <li>
          <div data-icon="&#xe040;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe040;">
        </li>
        <li>
          <div data-icon="&#xe041;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe041;">
        </li>
        <li>
          <div data-icon="&#xe044;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe044;">
        </li>
        <li>
          <div data-icon="&#xe045;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe045;">
        </li>
        <li>
          <div data-icon="&#xe046;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe046;">
        </li>
        <li>
          <div data-icon="&#xe047;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe047;">
        </li>
        <li>
          <div data-icon="&#xe048;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe048;">
        </li>
        <li>
          <div data-icon="&#xe049;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe049;">
        </li>
        <li>
          <div data-icon="&#xe04a;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe04a;">
        </li>
        <li>
          <div data-icon="&#xe04b;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe04b;">
        </li>
        <li>
          <div data-icon="&#xe04c;" class="icon"></div>
          <input type="text" readonly="readonly" value="&amp;#xe04c;">
        </li>
      </ul>
    </div>
    <script>(function() {
  var glyphs, i, len, ref;

  ref = document.getElementsByClassName('glyphs');
  for (i = 0, len = ref.length; i < len; i++) {
    glyphs = ref[i];
    glyphs.addEventListener('click', function(event) {
      if (event.target.tagName === 'INPUT') {
        return event.target.select();
      }
    });
  }

}).call(this);

    </script>
  </body>
</html>
